"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withCaching = exports.DefaultCachingConfiguration = void 0;
var tslib_1 = require("tslib");
var decoratedBackend_1 = require("../decoratedBackend");
var util_1 = require("@gooddata/util");
var securitySettings_1 = require("../decoratedBackend/securitySettings");
var execution_1 = require("../decoratedBackend/execution");
var catalog_1 = require("../decoratedBackend/catalog");
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var first_1 = tslib_1.__importDefault(require("lodash/first"));
var flow_1 = tslib_1.__importDefault(require("lodash/flow"));
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var partition_1 = tslib_1.__importDefault(require("lodash/partition"));
var sdk_model_1 = require("@gooddata/sdk-model");
var attributes_1 = require("../decoratedBackend/attributes");
//
// Execution caching
//
var WithExecutionCaching = /** @class */ (function (_super) {
    tslib_1.__extends(WithExecutionCaching, _super);
    function WithExecutionCaching(decorated, ctx) {
        var _this = _super.call(this, decorated) || this;
        _this.ctx = ctx;
        _this.execute = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var cacheKey, cache, cacheEntry, result, _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cacheKey = this.fingerprint();
                        cache = this.ctx.caches.execution;
                        cacheEntry = cache.get(cacheKey);
                        if (!cacheEntry) {
                            result = _super.prototype.execute.call(this)
                                .then(function (res) {
                                return new WithExecutionResultCaching(res, _this.createNew, _this.ctx);
                            })
                                .catch(function (e) {
                                cache.delete(cacheKey);
                                throw e;
                            });
                            cacheEntry = { result: result };
                            cache.set(cacheKey, cacheEntry);
                        }
                        _a = DefinitionSanitizingExecutionResult.bind;
                        return [4 /*yield*/, cacheEntry.result];
                    case 1: return [2 /*return*/, new (_a.apply(DefinitionSanitizingExecutionResult, [void 0, _b.sent(), this.createNew,
                            this.definition]))()];
                }
            });
        }); };
        _this.createNew = function (decorated) {
            return new WithExecutionCaching(decorated, _this.ctx);
        };
        return _this;
    }
    return WithExecutionCaching;
}(execution_1.DecoratedPreparedExecution));
/**
 * This DataView decorator makes sure that definition used in it is the same as the definition in the result.
 *
 * See the usage of this class in {@link DefinitionSanitizingExecutionResult} for more.
 */
var DefinitionSanitizingDataView = /** @class */ (function (_super) {
    tslib_1.__extends(DefinitionSanitizingDataView, _super);
    function DefinitionSanitizingDataView(decorated, result) {
        var _this = _super.call(this, decorated, result) || this;
        _this.definition = result.definition;
        return _this;
    }
    return DefinitionSanitizingDataView;
}(execution_1.DecoratedDataView));
/**
 * This ExecutionResult decorator makes sure that definitions used throughout the result are set
 * to the definitionOverride provided. This is useful with caching because different definitions may yield
 * the same cache key, but having the proper definition in the returned execution result is critical:
 * the definitions in the result must match the one which was used to request it.
 * This however is not always the case when using cached results, so we need to ensure it explicitly.
 *
 * See the usage of this class in {@link WithExecutionCaching} for more.
 */
var DefinitionSanitizingExecutionResult = /** @class */ (function (_super) {
    tslib_1.__extends(DefinitionSanitizingExecutionResult, _super);
    function DefinitionSanitizingExecutionResult(decorated, wrapper, definitionOverride) {
        var _this = _super.call(this, decorated, wrapper) || this;
        _this.readAll = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.withSanitizedDefinition;
                        return [4 /*yield*/, _super.prototype.readAll.call(this)];
                    case 1: return [2 /*return*/, _a.apply(this, [_b.sent()])];
                }
            });
        }); };
        _this.readWindow = function (offset, size) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.withSanitizedDefinition;
                        return [4 /*yield*/, _super.prototype.readWindow.call(this, offset, size)];
                    case 1: return [2 /*return*/, _a.apply(this, [_b.sent()])];
                }
            });
        }); };
        _this.withSanitizedDefinition = function (original) {
            return new DefinitionSanitizingDataView(original, _this);
        };
        _this.definition = definitionOverride;
        return _this;
    }
    return DefinitionSanitizingExecutionResult;
}(execution_1.DecoratedExecutionResult));
function windowKey(offset, size) {
    return "o(" + offset.join(",") + ")_s(" + size.join(",") + ")";
}
var WithExecutionResultCaching = /** @class */ (function (_super) {
    tslib_1.__extends(WithExecutionResultCaching, _super);
    function WithExecutionResultCaching(decorated, wrapper, ctx) {
        var _this = _super.call(this, decorated, wrapper) || this;
        _this.ctx = ctx;
        _this.readAll = function () {
            if (!_this.allData) {
                _this.allData = _super.prototype.readAll.call(_this).catch(function (e) {
                    _this.allData = undefined;
                    throw e;
                });
            }
            return _this.allData;
        };
        _this.readWindow = function (offset, size) {
            if (!_this.windows) {
                return _super.prototype.readWindow.call(_this, offset, size);
            }
            var cacheKey = windowKey(offset, size);
            var window = _this.windows.get(cacheKey);
            if (!window) {
                window = _super.prototype.readWindow.call(_this, offset, size).catch(function (e) {
                    if (_this.windows) {
                        _this.windows.delete(cacheKey);
                    }
                    throw e;
                });
                _this.windows.set(cacheKey, window);
            }
            return window;
        };
        if (cachingEnabled(_this.ctx.config.maxResultWindows)) {
            _this.windows = new util_1.LRUCache({ maxSize: _this.ctx.config.maxResultWindows });
        }
        return _this;
    }
    return WithExecutionResultCaching;
}(execution_1.DecoratedExecutionResult));
//
// Catalog caching
//
function optionsKey(options) {
    return json_stable_stringify_1.default(options);
}
var WithCatalogCaching = /** @class */ (function (_super) {
    tslib_1.__extends(WithCatalogCaching, _super);
    function WithCatalogCaching(decorated, ctx) {
        var _this = _super.call(this, decorated) || this;
        _this.ctx = ctx;
        _this.load = function () {
            var cache = _this.getOrCreateWorkspaceEntry(_this.workspace).catalogForOptions;
            var cacheKey = optionsKey(_this.options);
            var catalog = cache.get(cacheKey);
            if (!catalog) {
                catalog = _super.prototype.load.call(_this).catch(function (e) {
                    cache.delete(cacheKey);
                    throw e;
                });
                cache.set(cacheKey, catalog);
            }
            return catalog;
        };
        _this.createNew = function (decorated) {
            return new WithCatalogCaching(decorated, _this.ctx);
        };
        _this.getOrCreateWorkspaceEntry = function (workspace) {
            var cache = _this.ctx.caches.workspaceCatalogs;
            var cacheEntry = cache.get(workspace);
            if (!cacheEntry) {
                cacheEntry = {
                    catalogForOptions: new util_1.LRUCache({
                        maxSize: _this.ctx.config.maxCatalogOptions,
                    }),
                };
                cache.set(workspace, cacheEntry);
            }
            return cacheEntry;
        };
        return _this;
    }
    return WithCatalogCaching;
}(catalog_1.DecoratedWorkspaceCatalogFactory));
//
// Organization security settings caching
//
function validUrlInContextKey(url, context) {
    return context + "_" + json_stable_stringify_1.default(url);
}
var WithSecuritySettingsCaching = /** @class */ (function (_super) {
    tslib_1.__extends(WithSecuritySettingsCaching, _super);
    function WithSecuritySettingsCaching(decorated, ctx) {
        var _this = _super.call(this, decorated) || this;
        _this.ctx = ctx;
        _this.isUrlValid = function (url, context) {
            var cache = _this.getOrCreateSecuritySettingsEntry(_this.scope).valid;
            var cacheKey = validUrlInContextKey(url, context);
            var result = cache.get(cacheKey);
            if (!result) {
                result = _super.prototype.isUrlValid.call(_this, url, context).catch(function (e) {
                    cache.delete(cacheKey);
                    throw e;
                });
                cache.set(cacheKey, result);
            }
            return result;
        };
        _this.isDashboardPluginUrlValid = function (url, workspace) {
            var scope = "plugins_" + workspace;
            var cache = _this.getOrCreateSecuritySettingsEntry(scope).valid;
            var result = cache.get(url);
            if (!result) {
                result = _super.prototype.isDashboardPluginUrlValid.call(_this, url, workspace).catch(function (e) {
                    cache.delete(url);
                    throw e;
                });
                cache.set(url, result);
            }
            return result;
        };
        _this.getOrCreateSecuritySettingsEntry = function (scope) {
            var cache = _this.ctx.caches.securitySettings;
            var cacheEntry = cache.get(scope);
            if (!cacheEntry) {
                cacheEntry = {
                    valid: new util_1.LRUCache({
                        maxSize: _this.ctx.config.maxSecuritySettingsOrgUrls,
                        maxAge: _this.ctx.config.maxSecuritySettingsOrgUrlsAge,
                    }),
                };
                cache.set(scope, cacheEntry);
            }
            return cacheEntry;
        };
        return _this;
    }
    return WithSecuritySettingsCaching;
}(securitySettings_1.DecoratedSecuritySettingsService));
//
// Attributes caching
//
function refMatchesMdObject(ref, mdObject, type) {
    return (sdk_model_1.areObjRefsEqual(ref, mdObject.ref) ||
        sdk_model_1.areObjRefsEqual(ref, sdk_model_1.idRef(mdObject.id, type)) ||
        sdk_model_1.areObjRefsEqual(ref, sdk_model_1.uriRef(mdObject.uri)));
}
var firstDefined = flow_1.default(compact_1.default, first_1.default);
var WithAttributesCaching = /** @class */ (function (_super) {
    tslib_1.__extends(WithAttributesCaching, _super);
    function WithAttributesCaching(decorated, ctx, workspace) {
        var _this = _super.call(this, decorated) || this;
        _this.ctx = ctx;
        _this.workspace = workspace;
        _this.getAttributeDisplayForm = function (ref) {
            var cache = _this.getOrCreateWorkspaceEntry(_this.workspace).displayForms;
            var idCacheKey = sdk_model_1.isIdentifierRef(ref) ? ref.identifier : undefined;
            var uriCacheKey = sdk_model_1.isUriRef(ref) ? ref.uri : undefined;
            var cacheItem = firstDefined([idCacheKey, uriCacheKey].map(function (key) { return key && cache.get(key); }));
            if (!cacheItem) {
                cacheItem = _super.prototype.getAttributeDisplayForm.call(_this, ref).catch(function (e) {
                    if (idCacheKey) {
                        cache.delete(idCacheKey);
                    }
                    if (uriCacheKey) {
                        cache.delete(uriCacheKey);
                    }
                    throw e;
                });
                if (idCacheKey) {
                    cache.set(idCacheKey, cacheItem);
                }
                if (uriCacheKey) {
                    cache.set(uriCacheKey, cacheItem);
                }
            }
            return cacheItem;
        };
        _this.getAttributeDisplayForms = function (refs) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var cache, refsWithCacheResults, _a, withCacheHits, withoutCacheHits, _b, alreadyInCache, loadedFromServer, candidates;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        cache = this.getOrCreateWorkspaceEntry(this.workspace).displayForms;
                        refsWithCacheResults = refs.map(function (ref) {
                            var idCacheKey = sdk_model_1.isIdentifierRef(ref) ? ref.identifier : undefined;
                            var uriCacheKey = sdk_model_1.isUriRef(ref) ? ref.uri : undefined;
                            var cacheHit = firstDefined([idCacheKey, uriCacheKey].map(function (key) { return key && cache.get(key); }));
                            return { ref: ref, cacheHit: cacheHit };
                        });
                        _a = partition_1.default(refsWithCacheResults, function (_a) {
                            var cacheHit = _a.cacheHit;
                            return !!cacheHit;
                        }), withCacheHits = _a[0], withoutCacheHits = _a[1];
                        return [4 /*yield*/, Promise.all([
                                // await the stuff from cache, we need the data available (we cannot just return the promises)
                                Promise.all(withCacheHits.map(function (item) { return item.cacheHit; })),
                                // load items not in cache using the bulk operation
                                this.decorated.getAttributeDisplayForms(withoutCacheHits.map(function (item) { return item.ref; })),
                            ])];
                    case 1:
                        _b = _c.sent(), alreadyInCache = _b[0], loadedFromServer = _b[1];
                        // save newly loaded to cache for future reference
                        loadedFromServer.forEach(function (loaded) {
                            var promisifiedResult = Promise.resolve(loaded);
                            // save the cache item for both types of refs
                            cache.set(loaded.id, promisifiedResult);
                            cache.set(loaded.uri, promisifiedResult);
                        });
                        candidates = tslib_1.__spreadArrays(loadedFromServer, alreadyInCache);
                        return [2 /*return*/, refs.map(function (ref) {
                                var match = candidates.find(function (item) { return refMatchesMdObject(ref, item, "displayForm"); });
                                // if this bombs, some data got lost in the process
                                ts_invariant_1.default(match);
                                return match;
                            })];
                }
            });
        }); };
        _this.getOrCreateWorkspaceEntry = function (workspace) {
            var cache = _this.ctx.caches.workspaceAttributes;
            var cacheEntry = cache.get(workspace);
            if (!cacheEntry) {
                cacheEntry = {
                    displayForms: new util_1.LRUCache({
                        maxSize: _this.ctx.config.maxAttributeDisplayFormsPerWorkspace,
                    }),
                };
                cache.set(workspace, cacheEntry);
            }
            return cacheEntry;
        };
        return _this;
    }
    return WithAttributesCaching;
}(attributes_1.DecoratedWorkspaceAttributesService));
//
//
//
function cachedExecutions(ctx) {
    return function (original) {
        return new execution_1.DecoratedExecutionFactory(original, function (execution) { return new WithExecutionCaching(execution, ctx); });
    };
}
function cachedCatalog(ctx) {
    return function (original) { return new WithCatalogCaching(original, ctx); };
}
function cachedSecuritySettings(ctx) {
    return function (original) { return new WithSecuritySettingsCaching(original, ctx); };
}
function cachedAttributes(ctx) {
    return function (original, workspace) { return new WithAttributesCaching(original, ctx, workspace); };
}
function cachingEnabled(desiredSize) {
    return desiredSize !== undefined && desiredSize > 0;
}
function cacheControl(ctx) {
    var control = {
        resetExecutions: function () {
            var _a;
            (_a = ctx.caches.execution) === null || _a === void 0 ? void 0 : _a.clear();
        },
        resetCatalogs: function () {
            var _a;
            (_a = ctx.caches.workspaceCatalogs) === null || _a === void 0 ? void 0 : _a.clear();
        },
        resetSecuritySettings: function () {
            var _a;
            (_a = ctx.caches.securitySettings) === null || _a === void 0 ? void 0 : _a.clear();
        },
        resetAttributes: function () {
            var _a;
            (_a = ctx.caches.workspaceAttributes) === null || _a === void 0 ? void 0 : _a.clear();
        },
        resetAll: function () {
            control.resetExecutions();
            control.resetCatalogs();
            control.resetSecuritySettings();
            control.resetAttributes();
        },
    };
    return control;
}
function assertPositiveOrUndefined(value, valueName) {
    ts_invariant_1.default(value === undefined || value > 0, valueName + " to cache must be positive or undefined, got: " + value);
}
/**
 * @beta
 */
exports.DefaultCachingConfiguration = {
    maxExecutions: 10,
    maxResultWindows: 5,
    maxCatalogs: 1,
    maxCatalogOptions: 50,
    maxSecuritySettingsOrgs: 3,
    maxSecuritySettingsOrgUrls: 100,
    maxSecuritySettingsOrgUrlsAge: 300000,
    maxAttributeWorkspaces: 1,
    maxAttributeDisplayFormsPerWorkspace: 100,
};
/**
 * Adds caching layer on top of an existing analytical backend instance. It is currently possible to cache
 * results of executions and the workspace LDM catalog.
 *
 * @remarks see {@link CachingConfiguration} properties for more information.
 * @param realBackend - real backend to decorate with caching
 * @param config - caching configuration
 * @beta
 */
function withCaching(realBackend, config) {
    if (config === void 0) { config = exports.DefaultCachingConfiguration; }
    assertPositiveOrUndefined(config.maxCatalogOptions, "maxCatalogOptions");
    assertPositiveOrUndefined(config.maxSecuritySettingsOrgUrls, "maxSecuritySettingsOrgUrls");
    assertPositiveOrUndefined(config.maxSecuritySettingsOrgUrlsAge, "maxSecuritySettingsOrgUrlsAge");
    var execCaching = cachingEnabled(config.maxExecutions);
    var catalogCaching = cachingEnabled(config.maxCatalogs);
    var securitySettingsCaching = cachingEnabled(config.maxSecuritySettingsOrgs);
    var attributeCaching = cachingEnabled(config.maxAttributeWorkspaces);
    var ctx = {
        caches: {
            execution: execCaching ? new util_1.LRUCache({ maxSize: config.maxExecutions }) : undefined,
            workspaceCatalogs: catalogCaching ? new util_1.LRUCache({ maxSize: config.maxCatalogs }) : undefined,
            securitySettings: securitySettingsCaching
                ? new util_1.LRUCache({ maxSize: config.maxSecuritySettingsOrgs })
                : undefined,
            workspaceAttributes: attributeCaching
                ? new util_1.LRUCache({ maxSize: config.maxAttributeWorkspaces })
                : undefined,
        },
        config: config,
    };
    var execution = execCaching ? cachedExecutions(ctx) : identity_1.default;
    var catalog = catalogCaching ? cachedCatalog(ctx) : identity_1.default;
    var securitySettings = securitySettingsCaching ? cachedSecuritySettings(ctx) : identity_1.default;
    var attributes = attributeCaching ? cachedAttributes(ctx) : identity_1.default;
    if (config.onCacheReady) {
        config.onCacheReady(cacheControl(ctx));
    }
    return decoratedBackend_1.decoratedBackend(realBackend, { execution: execution, catalog: catalog, securitySettings: securitySettings, attributes: attributes });
}
exports.withCaching = withCaching;
//# sourceMappingURL=index.js.map